// --------------------------------------------
// ASCII Console Easter Egg
// --------------------------------------------

console.log("ASCII.js loaded");

(function () {
  if (!window.ASCII_URL) {
    console.error("ASCII_URL missing — did you add it in theme.liquid?");
    return;
  }

  fetch(window.ASCII_URL)
    .then(r => r.text())
    .then(text => {
      // Base responsive style (works on 13” → ultrawide)
      let asciiStyle = `
        color:#00ff00;
        background:black;
        font-family:monospace;
        font-size:0.55vw;
        line-height:0.95;
        letter-spacing:-0.4px;
        white-space:pre;
      `;

      // Optional fallback: ensure readability on very small screens
      if (window.innerWidth < 900) {
        asciiStyle = `
          color:#00ff00;
          background:black;
          font-family:monospace;
          font-size:8px;
          line-height:1;
          letter-spacing:-0.2px;
          white-space:pre;
        `;
      }

      console.log("%c" + text, asciiStyle);
    })
    .catch(err => {
      console.error("ASCII load error:", err);
    });
})();